import React, { useContext } from "react";
import { Row, Col, Typography, Divider } from "antd";
import { F8 } from "../../../assets";

import { LanguageContext } from "../../../context/Language.contex";

const { Title, Paragraph } = Typography;

const AboutUmkm = () => {
  const { language } = useContext(LanguageContext);
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#f5f8fc",
        padding: "40px",
        overflow: "hidden",
      }}
    >
      {/* Ornamen Blur Biru */}
      <div
        style={{
          position: "absolute",
          top: "150px",
          right: "0",
          width: "400px",
          height: "400px",
          background: "rgba(0, 166, 225, 0.3)",
          filter: "blur(150px)",
          zIndex: 1,
        }}
      />

      {/* Konten Utama */}
      <Row
        gutter={32}
        align="middle"
        style={{ position: "relative", zIndex: 2 }}
      >
        {/* Kolom Teks */}
        <Col xs={24} md={12}>
          <div style={{ textAlign: "left" }}>
            <Title level={4}>
              Industrial Company Indonesia
              {/* <strong style={{ color: "#1d3557" }}>UMKM Bojonggede</strong> */}
            </Title>
            <Divider
              style={{ marginTop: 4, marginBottom: 16, width: "60px" }}
            />

            <Paragraph
              style={{ fontSize: 14, color: "#2c3e50", lineHeight: "1.7" }}
            >
              {language[2]}
            </Paragraph>
          </div>
        </Col>

        {/* Kolom Gambar */}
        <Col xs={24} md={12}>
          <img
            src={F8}
            alt="CMI INDONESIA"
            style={{ width: "50%", borderRadius: 8 }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AboutUmkm;
